import React from 'react';
import { Popover, makeStyles } from "@material-ui/core";
import styled from 'styled-components';
import PropTypes from "prop-types";

const PeriodChooserPopover = props => {
  const classes = useStyles();

  return (
    <Popover
      id={props.visible ? "simple-popover" : undefined}
      open={props.visible}
      anchorEl={props.anchor}
      onClose={props.onHide}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      classes={{ paper: classes.paper }}
    >
      <div className="d-flex flex-column w-100">
        <Option onClick={props.onChange.bind(this, 0)}>Last 7 days</Option>
        <Option onClick={props.onChange.bind(this, 1)}>Last month</Option>
        <Option onClick={props.onChange.bind(this, 2)}>Last 3 months</Option>
        <Option onClick={props.onChange.bind(this, 3)}>Last 6 months</Option>
        <Option onClick={props.onChange.bind(this, 4)}>Last year</Option>
      </div>
    </Popover>
  );
};

PeriodChooserPopover.propTypes = {
  visible: PropTypes.bool,
  anchor: PropTypes.any,
  onHide: PropTypes.func,
  onChange: PropTypes.func,
};

PeriodChooserPopover.defaultProps = {
  visible: false,
  onChange: () => console.log("No onChange method given"),
  onHide: () => console.log("No onHide method given"),
};

const useStyles = makeStyles(() => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    width: '200px',
    borderRadius: "10px",
    marginTop: "5px",
    boxShadow: "-2px -1px 10px 2px rgba(192, 197, 223, 0.2)"
  }
}));

const Option = styled.div`
  padding: 15px;
  cursor: pointer;
  &:hover {
    background-color: #ddd8;
  }
`;

export default PeriodChooserPopover;